import { styled } from '@mui/system';
import COLORS from '../../../theme/Colors';

export const Container = styled('div')({
    display: 'flex',
    flexDirection: 'column',
    width:'100%',
    backgroundColor: '#F8FAFC', // Match the light background from image
    minHeight: '100vh',
    paddingBottom: '4rem',
    'html.dark &': {
        backgroundColor: '#000000',
    }
});

export const PageHeader = styled('div')({
    textAlign: 'center',
    padding: '3rem 0 2rem 0',
});

export const MainTitle = styled('h1')({
    fontFamily: 'Merriweather, Georgia, serif',
    color: '#202A5D',
    fontSize: '2.5rem',
    fontWeight: 700,
    marginBottom: '2rem',
});

// Breadcrumb Styles
export const BreadcrumbWrapper = styled('div')({
    backgroundColor: '#F1F5F9',
    borderBottom: '1px solid #E2E8F0',
    width: '100vw',
    position: 'relative',
    left: '50%',
    right: '50%',
    marginLeft: '-50vw',
    marginRight: '-50vw',
    marginTop: '-70px',
    zIndex: 10,
});

export const BreadcrumbInner = styled('div')({
    width: '85%',
    maxWidth: '1920px',
    margin: '0 auto',
    padding: '15px 1.5rem',
    display: 'flex',
    alignItems: 'center',
});

export const BreadcrumbContent = styled('div')({
    display: 'flex',
    alignItems: 'center',
    gap: '8px',
    fontFamily: 'Roboto, -apple-system, BlinkMacSystemFont, "Segoe UI", sans-serif',
    fontSize: '14px',
    fontWeight: 500,
    color: 'rgb(62, 63, 65)',
    textTransform: 'uppercase',
});

export const BreadcrumbLink = styled('span')({
    cursor: 'pointer',
    '&:hover': {
        textDecoration: 'underline',
    }
});

export const BreadcrumbSeparator = styled('span')({
    margin: '0 4px',
    color: '#94A3B8',
});

export const BreadcrumbCurrent = styled('span')({
    color: 'inherit',
});

// Tabs Styles
export const TabsContainer = styled('div')({
    display: 'flex',
    justifyContent: 'center',
    gap: '1rem',
    marginBottom: '3rem',
    flexWrap: 'wrap',
});

export const TabItem = styled('button', {
    shouldForwardProp: (prop) => prop !== 'active',
})((props) => ({
    padding: '10px 30px',
    borderRadius: '8px',
    border: 'none',
    cursor: 'pointer',
    fontSize: '0.95rem',
    fontWeight: 600,
    transition: 'all 0.2s',
    backgroundColor: props.active ? 'white' : 'transparent',
    color: props.active ? '#202A5D' : '#718096',
    boxShadow: props.active ? '0 4px 6px rgba(0,0,0,0.05)' : 'none',
    '&:hover': {
        backgroundColor: props.active ? 'white' : '#EDF2F7',
    },
    'html.dark &': {
        backgroundColor: props.active ? 'rgba(0, 99, 188, 0.2)' : 'transparent',
        color: props.active ? '#7fb8e8' : '#94a3b8',
    },
    'html.dark &:hover': {
        backgroundColor: props.active ? 'rgba(0, 99, 188, 0.2)' : '#111111',
    }
}));

export const CategoryTitle = styled('h2')({
    fontFamily: 'Merriweather, Georgia, serif',
    color: '#202A5D',
    fontSize: '1.75rem',
    fontWeight: 700,
    marginBottom: '2rem',
    textAlign: 'left',
});

export const ContentInner = styled('div')({
    width: '85%',
    maxWidth: '1400px',
    margin: '0 auto',
});

